import * as React from 'react';

import { Modal } from '../../../Modal';

import * as main from '../styles/main.module.scss';
import * as registration from '../styles/registration.module.scss';
import {AccessLimited} from "../../../AccessLimited";

export const Registration = ({ widget, giftText, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={registration.registration}>
      <div className={'container'}>
        <div className={`row ${registration.registration__wrapper}`}>
          <div className={`col-12 col-lg-6 ${registration.registration__course}`}>
            <span className={registration.registration__subtitle}>Курс</span>
            <h1 className={registration.registration__title}>
              «Английская грамматика
              <br />
              для детей»
            </h1>
            <span className={`${registration.registration__coursePrice} ${registration.registration__textLineThrough}`}>
              7 000 ₽
            </span>
            <div className={registration.registration__gift}>
              <span className={registration.registration__icon}></span>
              <div>
                <span className={`${registration.registration__subtitle} ${registration.registration__subtitleOrange}`}>
                  Бесплатно
                </span>
                {giftText}
              </div>
            </div>
            <p className={registration.registration__recommendation}>Рекомендуем проходить обучение на компьютере</p>
          </div>
          <div className={`col-12 col-lg-6 ${registration.registration__modal}`}>
            <button
              className={`${registration.registration__button} ${main.mainBtn}`}
              onClick={() => {
                setShowModal(true);
              }}
            >
              Зарегистрироваться
            </button>
            { accessLimited && <AccessLimited margin={"30px 0 0"} font={"14px"} align={"center"}/> }
          </div>
        </div>
      </div>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
